import { render } from "./typeIndex.vue?vue&type=template&id=c7290b56&scoped=true"
import script from "./typeIndex.vue?vue&type=script&lang=js"
export * from "./typeIndex.vue?vue&type=script&lang=js"

import "./typeIndex.vue?vue&type=style&index=0&id=c7290b56&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7290b56"]])

export default __exports__